<template lang="pug">
.product(
    ref="matrix"
    @mouseover.prevent.stop="focus('main')"
    @mouseleave.prevent.stop="leave"
)
    h3.title.headline
        .product-name {{ productName }}
        .price
            nobr {{ productPrice }}
    .row.product-row
        .images(ref="images")
            template(v-for="(media, i) in productImages")
                .break(v-if="i === 3")
                PreviewImage(
                    :media="media"
                    :product="product"
                    :key="media.id"
                    :small="i >= 3"
                )
                    //- img(v-lazy="getImagePath(image.image)" :style="{width: getImagePath(image.image).width}")
        .product-description
            .description(v-if="productDescription" v-html="productDescription")
            .properties
                .property(
                    v-for="prop in productProperties"
                    v-if="prop.value !== productDescription"
                )
                    span.prop-label(v-if="prop.label") {{ prop.label }}:
                    span(v-html="prop.value")
        .product-info
            //- .price
                h3.title
                    nobr {{ productPrice }}
            .arrow-container
                .arrow
    .row.matrix-row
        table.table.is-bordered(v-if="matrix.sizes.length && matrix.colors.length")
            th.is-center color
            th.is-center.image-header
            th.is-center(v-for="size in matrix.sizes") {{ size }}
            tr(v-for="(row, i) in matrix.rows")
                th.color-cell.is-center
                    span.label {{ row.label }}
                th.colorimage-cell(
                    v-if="row.image && row.image.cdn"
                    :style="{ backgroundImage: 'url(' + row.image.cdn + ')'}"
                )
                th.colorimage-cell(v-else)
                td(v-for="column in row.columns")
                    Article(
                        :article="column.article"
                        :product="product"
                    )
</template>

<script>
import { get, round, debounce, cloneDeep, each, find, findIndex, set, orderBy, filter } from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import Article from './Article.vue';
import PreviewImage from './PreviewImage.vue';
import { moneyFormat, findPrice } from '@/filters';

import store from '@/store';

export default {
    name: 'Matrix',
    components: {
        Article,
        PreviewImage
    },
    data() {
        return {
            sortingOrder: [
                'one size',
                'os',
                'xxs',
                'xs',
                's',
                'm',
                'l',
                'xl',
                'xxl'
                // '34',
                // '35',
                // '36',
                // '37',
                // '38',
                // '38',
                // '39',
                // '40',
                // '41',
                // '42',
                // '43',
                // '44',
                // '45'
            ]
        };
    },
    props: {
        product: {
            required: true,
            type: Object
        }
    },
    computed: {
        articles() {
            return get(this.product, 'articles') || [];
        },
        // tax() {
        //     return ((100 + this.defaultTax.value) / 100)
        // },
        productName() {
            return this.product.nr + ' ' + this.product.name;
        },
        productPrice() {
            const price = findPrice(this.product, this.customer, this.defaultCustomerGroup, true);
            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR';

            if (get(this.customer, 'show_net_prices')) {
                const taxRate = get(price, 'tax.value') || this.defaultTax.value;
                const tax = round((price.value * taxRate) / (100 + taxRate), 2);

                return moneyFormat((price.value - tax), code)
            } else {
                return moneyFormat(price.value, code)
            }
        },
        productDescription() {
            let value = get(this.product, 'description');
            // if (!value) value = find(this.productProperties, {'key': 'buchinfo'})
            // if (!value) value = ''
            // if (typeof value == 'object') return value.value
            return value;
        },
        productProperties() {
            let properties = [];
            let ignoredProperties = [
                'hersteller',
                'kollektion',
                'keywords',
                'produktgruppe',
                'ursprungsland',
                'pos',
                'groupsort',
                'qualität',
                'länge',
                'größe',
                'farbe'
            ];
            if (this.product.propertyPivots && this.product.propertyPivots.length > 0) {
                this.product.propertyPivots.forEach(propertyPivot => {
                    if (!propertyPivot.values || propertyPivot.values.length > 1) return;

                    const property = propertyPivot.property;
                    if (!ignoredProperties.includes(property.key.toLowerCase())) {
                        // let key = property.key
                        let object = {
                            key: property.key.toLowerCase(),
                            // label: property.key,
                            value: this.getPropertyValue(propertyPivot.values[0], property.propType)
                        };
                        properties.push(object);
                    }
                });
            }

            return properties;
        },
        productMedia() {
            return orderBy(this.product.media, 'position');
        },
        productImages() {
            return this.productMedia.filter(el => el.type === 'image');
        },
        productVideo() {
            return this.productMedia.filter(el => el.type === 'video');
        },
        matrix() {
            let matrix = {
                colors: this.colors,
                sizes: this.sizes,
                rows: []
            };

            let articles = _.cloneDeep(this.articles);
            articles.forEach(article => {
                // get color

                const colorPropertyPivot = article.propertyPivots.find(el => {
                    return ['color', 'colour', 'farbe'].includes(el.property.key.toString().toLowerCase());
                });

                const colorValue = get(colorPropertyPivot, 'value');
                const colorField = get(colorPropertyPivot, 'property.propType.value_field');
                const colorAltField = get(colorPropertyPivot, 'property.propType.value_field_alt');

                const color = colorValue[colorAltField] || colorValue[colorField];
                // if (!matrix.colors.includes(color)) matrix.colors.push(color)
                article.color = color;

                // get size

                const sizePropertyPivot = article.propertyPivots.find(el => {
                    return ['size', 'größe'].includes(el.property.key.toString().toLowerCase());
                });

                const sizeValue = get(sizePropertyPivot, 'value');
                const field = get(sizePropertyPivot, 'property.propType.value_field');
                const altField = get(sizePropertyPivot, 'property.propType.value_field_alt');

                const size = sizeValue[altField] || sizeValue[field];
                // if (!matrix.sizes.includes(size)) matrix.sizes.push(size)
                article.size = size;

                // // if there is no row with the current color label
                // // create a new one
                // if (! matrix.rows.find(el => el.label === color)) {
                //     matrix.rows.push({ label: color, columns: [] })
                // }
            });

            matrix.colors.forEach(color => {
                let row = {
                    label: color.color,
                    columns: [],
                    image: this.getColorImage(color.image)
                };
                matrix.sizes.forEach(size => {
                    const article = articles.find(el => el.color === color.color && el.size === size);
                    let column = { label: size, article: false };
                    if (article) column.article = article;
                    row.columns.push(column);
                });
                matrix.rows.push(row);
            });

            return matrix;
        },
        colors() {
            const colorPropertyPivot = this.product.propertyPivots.find(el => {
                return ['color', 'colour', 'farbe'].includes(el.property.key.toString().toLowerCase());
            });
            const colors = get(colorPropertyPivot, 'values');
            const field = get(colorPropertyPivot, 'property.propType.value_field');
            const altField = get(colorPropertyPivot, 'property.propType.value_field_alt');

            let values = [];
            if (colors && field) {
                values = colors.map(el => {
                    return { color: el[altField] || el[field], image: el.image };
                });
            }

            return values;

            // const items = cloneDeep(this.articles)
            // let colors = {}
            // each(items, item => {
            //     let colorProp = find(item.properties, prop => {
            //         const key = get(prop, 'key')
            //         if (key && ['color', 'colour', 'farbe'].includes(key.toString().toLowerCase())) {
            //             return prop
            //         }
            //     })
            //     if (colorProp) {
            //         let colorValue, colorLabel, colorImage  = undefined

            //         if (get(colorProp.pivot, 'text')) {
            //             colorLabel = get(colorProp.pivot, 'text')
            //         }
            //         if (get(colorProp.pivot, 'color')) {
            //             colorValue = get(colorProp.pivot, 'color')
            //         }
            //         if (get(colorProp.pivot, 'image')) {
            //             colorImage = get(colorProp.pivot, 'image')
            //         }
            //         let colorName = this.product.id + '-' + this.stringToHash(colorLabel)
            //         if (!colors[colorName] || !colors[colorName]['key'] || colors[colorName]['key'] != colorName) {
            //             set(colors, colorName, {
            //                 label: colorLabel, value: colorValue, image: colorImage, key: colorName
            //             })
            //         }
            //         if (!colors[colorName]['label'] && colorLabel) {
            //             set(colors, `${colorName}.label`, {
            //                 label: colorLabel
            //             })
            //         }
            //         if (!colors[colorName]['value'] && colorValue) {
            //             set(colors, `${colorName}.value`, {
            //                 value: colorValue
            //             })
            //         }
            //         if (!colors[colorName]['image'] && colorImage) {
            //             set(colors, `${colorName}.image`, {
            //                 image: colorImage
            //             })
            //         }
            //     }
            // })
            // return orderBy(colors, 'label')
        },
        sizes() {
            const sizePropertyPivot = this.product.propertyPivots.find(el => {
                return ['size', 'größe'].includes(el.property.key.toString().toLowerCase());
            });
            const sizes = get(sizePropertyPivot, 'values');
            const field = get(sizePropertyPivot, 'property.propType.value_field');
            const altField = get(sizePropertyPivot, 'property.propType.value_field_alt');

            let values = [];
            if (sizes && field) {
                values = sizes.map(el => el[altField] || el[field]);
            }

            values.sort((a, b) => {
                console.log()
                let nra = a;
                let nrb = b;
                if (get(sizePropertyPivot, 'property.propType.key') !== 'number') {
                    a = a.toLowerCase();
                    b = b.toLowerCase();

                    nra = parseInt(a);
                    nrb = parseInt(b);
                }

                if (this.sortingOrder.indexOf(a) != -1) nra = NaN;
                if (this.sortingOrder.indexOf(b) != -1) nrb = NaN;

                if (nrb === 0) return 1;
                if ((nra && !nrb) || nra === 0) return -1;
                if (!nra && nrb) return 1;
                if (nra && nrb) {
                    if (nra == nrb) {
                        return a.substr(('' + nra).length).localeCompare(a.substr(('' + nra).length));
                    } else {
                        return nra - nrb;
                    }
                } else {
                    return this.sortingOrder.indexOf(a) - this.sortingOrder.indexOf(b);
                }
            });
            return values;
            // return this.sortingOrder.filter(x => new Set(values).has(x));
            // return values

            // let sizeProperties = []
            // each(this.articles, item => {
            //     let sizeProp = filter(item.properties, prop => {
            //         const key = get(prop, 'key')
            //         if (key && ['size', 'größe'].includes(key.toString().toLowerCase())) {
            //             return prop
            //         }
            //     })

            //     if (sizeProp) {
            //         each(sizeProp, prop => {
            //             let size = undefined
            //             let sizePropTypeValue = get(prop, 'propType.value_field')
            //             if (get(prop.pivot, sizePropTypeValue)) {
            //                 size = get(prop.pivot, sizePropTypeValue)
            //             } else {
            //                 let sizePropTypeAltValue = get(prop, 'propType.value_field_alt')
            //                 if (get(prop.pivot, sizePropTypeAltValue)) {
            //                     size = get(prop.pivot, sizePropTypeAltValue)
            //                 }
            //             }
            //             let sizeIndex = findIndex(sizeProperties, ['size', size])
            //             if (sizeIndex == -1) {
            //                 sizeProperties.push({id: prop.pivot.id, size })
            //             }
            //         })
            //     }
            // })

            // sizeProperties.forEach(prop => {
            //     const size = get(prop, 'size')
            //     if (size) {
            //         switch (size.toString().toLowerCase()) {
            //             case 'os':
            //                 prop.position = 0
            //                 break;
            //             case 'xs':
            //                 prop.position = 1
            //                 break;
            //             case 's':
            //                 prop.position = 2
            //                 break;
            //             case 'm':
            //                 prop.position = 3
            //                 break;
            //             case 'l':
            //                 prop.position = 4
            //                 break;
            //             case 'xl':
            //                 prop.position = 5
            //                 break;
            //         }
            //     }
            // })
            // return orderBy(sizeProperties, ['position', 'size'], 'asc')
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'defaultCustomerGroup',
            cart: 'shop/cart',
            defaultTax: 'defaultTax'
        })
    },
    methods: {
        getColorImage(image) {
            if (!image || !image.source) return undefined;
            let width = image.width;
            let height = image.height;

            const aspectRatio = width / height;
            const maxHeight = 200;

            if (height > maxHeight) {
                height = maxHeight;
                width = height * aspectRatio;
            }

            let root = '';
            const endpoint = process.env.VUE_APP_API_ENDPOINT;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            return {
                cdn: image.source.url,
                src: `${base}${image.id}/${image.source.name}?fit&h=${height}&format=webp`,
                error: `${base}${image.id}/${image.source.name}?fit&h=${height}&preview=greyscale`,
                loading: `${base}${image.id}/${image.source.name}?fit&h=${height}&preview=blur`,
                width,
                height,
                aspectRatio
            };
        },
        focus(media) {
            this.setFocusedMedia({ product: this.product, media });
        },
        leave() {
            this.removeFocusedMedia();
        },
        // getArticle(color, size) {
        //     let articleSize, articleColor
        //     let articles = cloneDeep(this.sortedArticles)
        //     articleColor = articles[color.key]
        //     if (articleColor) {
        //         articleSize = articleColor[size.size]
        //         if (articleSize) {
        //             return articleSize.article
        //         }
        //     }
        //     return false
        // },
        stringToHash(string) {
            if (!string) return undefined;
            string = string.toString();

            var hash = 0;
            if (string && string.length == 0) return hash;

            for (let i = 0; i < string.length; i++) {
                let char = string.charCodeAt(i);
                hash = (hash << 5) - hash + char;
                hash = hash & hash;
            }

            return hash;
        },
        getPropertyValue(data, propType) {
            return get(data, propType.value_field_alt) || get(data, propType.value_field);
        },
        calculateVisiblity() {
            const isInViewport = element => {
                if (!element) return false;

                let height = window.innerHeight;

                const style = getComputedStyle(element);
                const rect = element.getBoundingClientRect();

                // const top = rect.top + window.scrollY;
                const top = rect.top + parseFloat(style.paddingTop);
                const bottom = rect.bottom + parseFloat(style.paddingBottom);

                // default visible| if the element is fully in viewport
                //                | or too large for the viewport
                let visible = (bottom < height && top > 0) || (bottom > height && top < 0);

                // mobile visible| if .main-media > figure is at least for 66% in viewport
                //               | or too large for the viewport
                if (height < 500 || element.clientHeight > height / 2) {
                    visible =
                        (top > -100 && bottom < height + element.clientHeight / 2) || (bottom > height && top < 0);
                }

                // if (this.product.nr === '2213251101') {
                //   console.clear();
                //   console.log('top:', top);
                //   console.log('bottom:', bottom);
                //   console.log('height:', height);
                //   console.log('client height:', element.clientHeight);
                //   console.log('===================');
                //   console.log('visible: ', visible);
                //   console.log('===================');
                // }

                return visible;
            };

            if (isInViewport(this.$refs.images)) {
                if (!this.product.articles) this.fetchProductArticles(parseInt(this.product.id));
                this.addVisibleProduct(this.product);
            } else {
                this.removeVisibleProduct(this.product);
            }
        },
        ...mapMutations({
            addVisibleProduct: 'shop/addVisibleProduct',
            removeVisibleProduct: 'shop/removeVisibleProduct',
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        }),
        ...mapActions({
            fetchProductArticles: 'shop/fetchProductArticles'
        })
    },
    mounted() {
        window.addEventListener('scroll', debounce(this.calculateVisiblity, 150));
        this.calculateVisiblity();
    },
    beforeDestroy() {
        store.commit('shop/clearVisibleProducts');
        store.commit('shop/removeFocusedMedia');

        const container = document.querySelector('#view > .preorder-columns > .column.left > .ps');
        if (container) container.removeEventListener('scroll', this.calculateVisiblity);
    }
};
</script>

<style lang="sass">

@import "~bulma/sass/utilities/mixins";

h3.title
    font-size: 24px
    &.headline
        margin-bottom: .5rem !important
        margin-top: 1rem
        display: flex
        justify-content: space-between

.table
    width: 100%
th.is-center
    text-align: center
.color-cell
    padding: 0 !important
    // height: 110px
    text-align: center
    .label
        padding: 9px
.colorimage-cell
    padding: 0 !important
    height: 45px
    width: 45px
    text-align: center
    background-position: center
    background-size: cover
    background-repeat: no-repeat
.image-header
    padding: 0!important
.stylebox
    width: 100px
    height: 100px
    border-bottom: 1px solid #ededed
.colorname
    text-align: center
.matrix-row
    // padding-bottom: 50px
    border-bottom: 1px solid #000
    &:last-of-type
        border-bottom: 0
.product-row
    display: flex
    flex-direction: row
    // padding-top: 50px
    justify-content: space-between
    margin-bottom: 20px
    +mobile
        flex-direction: column
    .product-description
        padding: 0 15px
        display: flex
        flex-direction: column
        justify-content: space-between
        flex-grow: 1
        .properties
            flex-grow: 1
        +mobile
            padding: 15px 0 15px 0
    .images
        // display: flex
        // flex-direction: row
        // flex-shrink: 0
        // flex-wrap: wrap
        margin: -5px
        flex-shrink: 0
        +mobile
            max-width: 100%
        .break
            flex-basis: 100%
            height: 0

.arrow-container
    opacity: 0
    justify-content: flex-end
    right: -30px
    position: relative
    // padding-top: 20px
    display: none
    height: 150px
    +desktop
        display: flex
    .arrow
        width: 0
        height: 0
        border-top: 75px solid transparent
        border-bottom: 75px solid transparent
        border-left: 20px solid black
.prop-label:after
    content: ' '
</style>
